export enum Layout {
  Empty = 'empty',
  EmptyPageLayout = 'emptyPageLayout',
  Profile = 'profile',
  Reports = 'reports',
  Settings = 'settings',
}
